import routeName from '@/router/constant';

const typeName = 'letter';

export const letterRoute = [
    {
        path: `/${typeName}-ssoLogin`,
        name: routeName.LETTER_SSO_LOGIN,
        component: () => import('@/views/letter/landingPage/Index.vue'),
        meta: {
            auth: false,
            metaTitle: '單一登入',
            pageTitle: '單一登入',
        },
    },
];

export const letterHeader = [
    {
        path: `${typeName}-login`,
        name: routeName.LETTER_LOGIN,
        component: () => import('@/views/letter/login/Index.vue'),
        meta: {
            auth: false,
            metaTitle: '會員登入',
            pageTitle: '會員登入',
        },
    },
];
